import { Controller } from 'stimulus';
import { templateContent } from '@/js/util';

// Opens the product image in the UI::TwinTurboModal rendered into the modal template.
export default class extends Controller {
  static targets = ['modal'];

  open(event) {
    event.preventDefault();

    document.body.append(templateContent(this.modalTarget));
  }
}
